export enum Mode {
  DEVELOPMENT = 'dev',
  STAGING = 'staging',
  PROD = 'prod',
  RC = 'rc',
}
